import GroupWorkIcon from "@mui/icons-material/GroupWork";
import ListSpecialitiesGroups from "./List";
import { AdministrationServicePath, SPECIALITY_GROUPS } from "utils/constants";
import EditSpecialitiesGroup from "./Edit";
import CreateSpecialitiesGroup from "./Create";
import { tenants } from "utils/tenants";
import permissions from "app/permissions";

//permissions
export const resources = {
  isMenu: true,
  tenancies: [tenants.MU],
  icon: <GroupWorkIcon />,
  name: AdministrationServicePath + SPECIALITY_GROUPS,
  title: "Групи специалности",
  list: <ListSpecialitiesGroups />,
  permission: permissions.canPreviewSpecialityGroups,
  create: <CreateSpecialitiesGroup />,
  createPermission: permissions.canManageSpecialityGroups,
  edit: <EditSpecialitiesGroup />,
  editPermission: permissions.canManageSpecialityGroups,
};
